export enum ClassificationType {
Income,
Expenses,
}
